import { z } from "zod";
/**
 * Zod schema for TourAudienceCriteria — the shape stored in
 * `tour_audiences.criteria` and `tour_steps.visibility_criteria`.
 *
 * Kept in shared so both the admin API route (admin-tours.ts) and the
 * CSV import pipeline (csv-import.ts) validate against the same
 * definition without drift.  Previously criteriaSchema was defined
 * locally in admin-tours.ts and never reached the import path, leaving
 * step_visibility_criteria accepted as any arbitrary JSON object.
 *
 * `.strict()` rejects unknown keys so future schema additions are
 * caught at the boundary rather than silently stored.
 */
export const criteriaSchema = z
    .object({
    roles: z.array(z.string().min(1)).optional(),
    onboardingState: z.enum(["new", "completed", "any"]).optional(),
    locations: z.array(z.string().min(1)).optional(),
    milestones: z
        .object({
        has: z.array(z.string().min(1)).optional(),
        lacks: z.array(z.string().min(1)).optional(),
    })
        .optional(),
})
    .strict();
